<template>
	<div>
		<az-toolbar>
			<template #simpleSearch>
				<az-search
					class="advanced-search-processo"
					:filter="filtro"
					v-az-auth="permissoes.ataListar"
					simple-search-placeholder="Busque por N° Ata, N° Processo ou Objeto"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
					@advanced-search="buscar"
					@clear="limparBusca"
				>
					<template #search-items>
						<az-search-item>
							<v-text-field label="Objeto" v-model="filtroInterno.objeto.value"></v-text-field>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Orgão"></label-personalizado>
							<v-autocomplete
								id="combo-autocomplete-processos"
								v-model="filtroInterno.siglaOrgao.value"
								name="Orgao"
								dense
								clearable
								:items="listaOrgaos"
								placeholder="Escolha o órgão"
								class="pt-0"
								item-value="siglaOrgao"
								item-text="siglaDescricao"
							></v-autocomplete>
						</az-search-item>
					</template>
				</az-search>
			</template>
		</az-toolbar>
		<az-container class="listagem">
			<processo-utilizacao-listagem
				:itens="datasource"
				:total-paginas="totalPaginas"
				:total-itens="totalItens"
				:paginacao="paginacao"
				@paginar="setPaginacaoListagem"
				@resetar-page="resetarPaginaItemListagem()"
			></processo-utilizacao-listagem>
		</az-container>
	</div>
</template>

<script>
import ProcessoUtilizacaoListagem from './listagem/ProcessoUtilizacaoListagem.vue'

import { actionTypes } from '@/core/constants'
import { mapState } from 'vuex'
import _ from 'lodash'
import mutationTypes from '@/core/constants/mutation-types'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import ProcessoUtilizacao from '@/core/store/processo-utilizacao'

export default {
	name: 'processo-utilizacao',
	components: {
		ProcessoUtilizacaoListagem,
	},
	mixins: [permissoesMixin],
	data() {
		return {
			datasource: [],
			totalPaginas: 0,
			tabs: [],
			totalItens: 0,
			filtroInterno: this.getFiltros(),
			paginacao: this.$store.state.processoUtilizacao.paginacao,
			quantidadeAdesoes: 0,
			listaOrgaos: [],
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.processoUtilizacao.filtro,
		}),
	},
	async mounted() {
		this.$store.commit(mutationTypes.PROCESSO_UTILIZACAO.RESET_INFORMACOES)
		await this.carregarProcessosUtilizacao()
		await this.buscarOrgaos()
		this.limparBusca()
	},
	methods: {
		getFiltros() {
			return _.cloneDeep(this.$store.state.processoUtilizacao.filtro)
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
				this.filtroInterno[propriedade].value = this.filtroInterno[propriedade].default
			}
			await this.carregarProcessosUtilizacao()
		},
		async buscar(searchText) {
			if (searchText) this.filtro.numeroAtaOuNumeroProcessoOuIdProcessoOuObjeto.value = searchText
			this.filtro.objeto.value = this.filtroInterno.objeto.value
			this.filtro.siglaOrgao.value = this.filtroInterno.siglaOrgao.value
			this.resetarPaginaItemListagem()
			await this.carregarProcessosUtilizacao()
		},
		async buscarOrgaos() {
			const orgaos = await this.$store.dispatch(actionTypes.PROCESSO_UTILIZACAO.BUSCAR_ORGAOS)
			this.listaOrgaos = orgaos.itens
		},
		async carregarProcessosUtilizacao() {
			const retorno = await this.$store.dispatch(actionTypes.PROCESSO_UTILIZACAO.BUSCAR_POR_FILTRO)
			this.totalPaginas = retorno.totalPages
			this.totalItens = retorno.totalElements
			this.datasource = retorno.itens
		},
		setPaginacaoListagem(paginacao) {
			this.$store.commit(mutationTypes.PROCESSO_UTILIZACAO.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarProcessosUtilizacao()
		},
		limparBusca() {
			this.$store.commit(mutationTypes.PROCESSO_UTILIZACAO.LIMPAR_FILTRO_LISTAGEM)
			this.filtroInterno = this.getFiltros()
			this.carregarProcessosUtilizacao()
		},
		resetarPaginaItemListagem() {
			this.$store.commit(mutationTypes.PROCESSO_UTILIZACAO.RESETAR_PAGINA_LISTAGEM)
		},
	},
}
</script>

<style lang="stylus">

.advanced-search-processo .simple-search .input-search
	overflow-x scroll
	scrollbar-width: none
</style>
